import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRecoilValue } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { AppLinkButton, DataSet, DataTable, DataTableRow, DataTableRowContent, DataTableRowFooter, DataTableRowHeader, Tag, } from '@zurich/ui/legacy/components';
import { offerDetailsAtom } from '../../../recoil/atoms/policy';
const partyDetailsButtonDisallowList = [
    'intermediary', // Vermittler
    'transferabilityOwner', // Vinkulargläubiger
    'producer', // Produktionär
];
const getFullname = (person, t) => {
    if (!person)
        return null;
    return [
        // TODO: why does this not have the same structure as Party.getName()...
        person.gender && t(`policy.partySalutation.${person.gender}`),
        person.degreePreFix,
        person.firstName,
        person.lastName,
        person.degreePostFix,
    ]
        .filter((v) => !!v)
        .join(' ');
};
function showPartyDetailsButton(roleType) {
    if (!roleType) {
        return false;
    }
    return !partyDetailsButtonDisallowList.includes(roleType);
}
const getContactInformation = (person, contactType) => person?.contactRoles?.find((cr) => cr?.contactInformation?.contactType === contactType)?.contactInformation?.value;
export function PolicyDetailParticipantsTable() {
    const { t } = useTranslation();
    const offer = useRecoilValue(offerDetailsAtom);
    const getParticipantParty = (partyId) => offer.parties?.find((party) => party.partyId === partyId);
    return offer.participantRoles ? (_jsx(DataTable, { children: offer.participantRoles.map((participantRole, index) => {
            const participantParty = participantRole.partyId
                ? getParticipantParty(participantRole.partyId)
                : null;
            return (participantParty && (_jsxs(DataTableRow, { rowGap: 3, children: [_jsx(DataTableRowHeader, { title: _jsx(DataSet, { data: [
                                participantParty.companyName && offer.system === 'INSIS'
                                    ? participantParty.companyName
                                    : getFullname(participantParty, t),
                            ], caption: t('policy.partyName') }), tags: showPartyDetailsButton(participantRole.type) && (_jsx(AppLinkButton, { href: `/party/${participantParty.partyId}`, color: "primary", children: t('policy.partyDetailsLink').toUpperCase() })), editable: false }), _jsx(DataTableRowContent, { data: [
                            {
                                // TODO: mobile phone or private phone?
                                data: [
                                    getContactInformation(participantParty, 'mobilePhone'),
                                ],
                                caption: t('policy.partyPhoneNumberMobile'),
                            },
                            {
                                data: [
                                    getContactInformation(participantParty, 'emailAddress'),
                                ],
                                caption: t('policy.partyEmail'),
                            },
                            {
                                data: [
                                    getContactInformation(participantParty, 'privatePhone'),
                                ],
                                caption: t('policy.partyPhoneNumberPrivate'),
                            },
                            // TODO: show value of Fax -> not available...
                            {
                                data: [participantParty?.partyId],
                                caption: participantRole.type === 'intermediary'
                                    ? t('policy.intermediaryNumber')
                                    : t('policy.partyNumber'),
                            },
                        ], maxColumns: 4 }), _jsx(DataTableRowFooter, { children: _jsx(Tag, { variant: "grey", children: t(`policy.participantRole.${participantRole.type ?? 'unknown'}`) }, participantRole.type) })] }, `participantParty_${participantParty.partyId ?? ''}_${index}`)));
        }) })) : (_jsx(_Fragment, {}));
}
